import { Component, OnInit, HostListener } from '@angular/core';
import {Router} from '@angular/router';
import {Proveedor} from 'src/app/interfaces/proveedor.interface';
import {VentaService} from 'src/app/services/venta.service';
import {Salida} from 'src/app/interfaces/salida.interface';

@Component({
  selector: 'app-salidas',
  templateUrl: './salidas.component.html',
  styles: [
  ]
})
export class SalidasComponent implements OnInit {

  monto = '0';
  proveedores: Proveedor[] = [];
  indice = 0;

  constructor(
    public ventaService: VentaService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.obtenerProveedores();
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event.keyCode === 27) {
      this.router.navigate(['/venta']);
    } else if (
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    ) {
      this.monto += event.key;

    } else if (event.keyCode === 8) {
      this.monto = '0';

    } else if (event.keyCode === 13) {
      this.guardarSalida();
    } else if (event.keyCode === 38) {
      this.restarIndice();
    } else if (event.keyCode === 40) {
      this.sumarIndice();
    }
  }

  restarIndice() {
    if (this.indice > 0) {
      this.indice--;
    }
  }

  sumarIndice() {
    if (this.indice < this.proveedores.length - 1) {
      this.indice++;
    }
  }

  async obtenerProveedores() {
    try {
      const response = await this.ventaService.obtenerProveedores();
      //this.proveedores = response;
    } catch (error) {
      console.log(error);
    }
  }

  async guardarSalida() {
    const monto = Number.parseInt(this.monto, 10);

    if (monto > 0) {
      const salida: Salida = {
        proveedor: this.proveedores[this.indice],
        monto
      };

      this.ventaService.caja.salidas.push(salida);

      await this.ventaService.actualizarSalida();
      this.router.navigateByUrl('/venta');

    }
  }

}
